import type { Privilege } from "../privilege.common";
import type { InvoiceItem, MikrotikParam } from "../types.common";

export class FakeBase {
    protected get unimplemented() {
        return () => {
            throw new Error("Unimplemented.");
        };
    }

    public get random(): {
        string: () => string;
        number: () => number;
        rating: () => number;
        phrase: () => string;
        select: <T>(selection: T[]) => () => T;
        selectMany: <T>(selection: T[]) => () => T[];
        selectFn: <T>(selection: T[]) => T;
        selectManyFn: <T>(selection: T[]) => T[];
    } {
        return {
            string: this.unimplemented,
            number: this.unimplemented,
            rating: this.unimplemented,
            phrase: this.unimplemented,
            select: () => this.unimplemented,
            selectMany: () => this.unimplemented,
            selectFn: this.unimplemented,
            selectManyFn: this.unimplemented,
        };
    }

    public get person(): {
        name: () => string;
        email: () => string;
        username: () => string;
        password: () => string;
        phone: () => string;
        idnum: () => string;
        privilegeList: (privilegeMap: Privilege.Map) => () => Record<Privilege.Names, boolean>;
    } {
        return {
            name: this.unimplemented,
            email: this.unimplemented,
            username: this.unimplemented,
            password: this.unimplemented,
            phone: this.unimplemented,
            idnum: this.unimplemented,
            privilegeList: () => this.unimplemented,
        };
    }

    public get company(): {
        name: () => string;
        position: () => string;
        privilegeName: () => string;
    } {
        return {
            name: this.unimplemented,
            position: this.unimplemented,
            privilegeName: this.unimplemented,
        };
    }

    public get location(): {
        name: () => string;
        address: () => string;
        coordinate: () => string;
    } {
        return {
            name: this.unimplemented,
            address: this.unimplemented,
            coordinate: this.unimplemented,
        };
    }

    public get pop(): {
        radius: () => number;
        capacity: () => number;
    } {
        return {
            radius: this.unimplemented,
            capacity: this.unimplemented,
        };
    }

    public get account(): {
        name: () => string;
        bank: () => string;
        number: () => string;
        initialBalance: () => number;
    } {
        return {
            name: this.unimplemented,
            bank: this.unimplemented,
            number: this.unimplemented,
            initialBalance: this.unimplemented,
        };
    }

    public get network(): {
        ipv4: () => string;
        cidr: () => number;
        port: () => number;
    } {
        return {
            ipv4: this.unimplemented,
            cidr: this.unimplemented,
            port: this.unimplemented,
        };
    }

    public get product(): {
        name: () => string;
        code: () => string;
        price: () => number;
    } {
        return {
            name: this.unimplemented,
            code: this.unimplemented,
            price: this.unimplemented,
        };
    }

    public get invoice(): {
        tax: () => number;
        products: () => InvoiceItem[];
    } {
        return {
            tax: this.unimplemented,
            products: this.unimplemented,
        };
    }

    public get hotspot(): {
        name: () => string;
        price: () => number;
        profit: () => number;
        dnsName: () => string;
        quantity: () => number;
        codeLength: () => number;
        timeLimit: () => number;
        userLimit: () => number;
        activeDays: () => number;
    } {
        return {
            name: this.unimplemented,
            price: this.unimplemented,
            profit: this.unimplemented,
            dnsName: this.unimplemented,
            quantity: this.unimplemented,
            codeLength: this.unimplemented,
            timeLimit: this.unimplemented,
            userLimit: this.unimplemented,
            activeDays: this.unimplemented,
        };
    }

    public get nas(): {
        name: () => string;
        secret: () => string;
    } {
        return {
            name: this.unimplemented,
            secret: this.unimplemented,
        };
    }

    public get radius(): {
        name: () => string;
        profile: () => string;
        timeLimit: () => number;
        quotaLimit: () => number;
        speedLimit: () => number;
        username: () => string;
        password: () => string;
        params: () => MikrotikParam;
    } {
        return {
            name: this.unimplemented,
            profile: this.unimplemented,
            timeLimit: this.unimplemented,
            quotaLimit: this.unimplemented,
            speedLimit: this.unimplemented,
            username: this.unimplemented,
            password: this.unimplemented,
            params: this.unimplemented,
        };
    }

    public get item(): {
        name: () => string;
        group: () => string;
        category: () => string;
    } {
        return {
            name: this.unimplemented,
            group: this.unimplemented,
            category: this.unimplemented,
        };
    }
}
